module.exports = __webpack_public_path__ + "img/BrandMe_IA_HombreLunaGuitarra_8.fcf71edf.png";